import { ChallengeDemo } from '@/components/challenges/demos/ChallengeDemo';
import { useChallengeContext } from '@/pages/challenges/useChallengeContext';
import { Skeleton } from '@startupquickstart/frontend';

/** Demo tab on the library challenge detail page — playable minigame preview. */
export function ChallengeDemoTab() {
  const { challenge, isLoading } = useChallengeContext();

  if (isLoading) return <Skeleton className="h-64 rounded-xl" />;
  if (!challenge) {
    return (
      <div className="py-12 text-center">
        <p className="text-muted-foreground">Challenge not found</p>
      </div>
    );
  }

  return <ChallengeDemo challenge={challenge} />;
}
